const scrollMixins = {
  data() {
    return {
      // 下拉刷新的配置(可选)
      downOption: {
        auto: false,
      },
      // 上拉加载的配置(可选)
      upOption: {
        auto: false, // 是否在初始化完毕之后自动执行一次上拉加载的回调
        page: {
          size: 10, // 每页数据的数量,默认10
        },
        noMoreSize: 5, // 配置列表的总数量要大于等于5条才显示'-- END --'的提示
        textLoading: '加载更多...',
        textNoMore: '-- 暂无更多数据 --',
        empty: {
          use: true,
          tip: '暂无数据',
          // btnText: '点击刷新',
        },
        isBounce: true,
      },
    };
  },
};
export default scrollMixins;
